import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'
import { connectTransfers as endpoints } from '../api_urls'
import { client } from '../utils'
import ButterToast, { Cinnamon } from 'butter-toast'

const ExportModal = props => {
  const [exportModalOpen, toggleExportModalOpen] = useState(false)
  const [exportWorking, toggleExportWorking] = useState(false)

  const handleExportClick = () => {
    toggleExportWorking(true)
    client
      .post(endpoints.exportRecentTransfers(), {
        account_id: props.accountID,
      })
      .then(() => {
        ButterToast.raise({
          content: (
            <Cinnamon.Crisp
              title="Export Started"
              content="We have started exporting your payments and the file will be available shortly. Refresh this page to see changes."
              scheme={Cinnamon.Crisp.SCHEME_BLUE}
              icon={<i className="far fa-check fa-3x" />}
            />
          ),
        })
        toggleExportWorking(false)
        toggleExportModalOpen(false)
      })
      .catch(err => {
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Error"
              content={`There was an error trying to export the payments. Please contact us if the error continues. ${err}`}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-exclamation-triangle fa-3x" />}
            />
          ),
        })
        toggleExportWorking(false)
      })
  }

  return (
    <React.Fragment>
      <div className="pull-right">
        <button
          className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
          onClick={() => toggleExportModalOpen(true)}
        >
          Export <div className="far fa-external-link-square ml-2" />
        </button>
      </div>
      <Modal show={exportModalOpen}>
        <Modal.Header>
          <Modal.Title>Export Payments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>The past six weeks of data will be exported.</p>
          <p>
            If you would like a report with a different time period, please
            contact us.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-myed btn-default btn-default-myed"
            onClick={() => toggleExportModalOpen(false)}
          >
            <div className="far fa-times mr-2" /> Cancel
          </Button>
          <Button
            disabled={exportWorking}
            className="btn btn-success btn-myed btn-success-myed"
            onClick={() => handleExportClick()}
          >
            <div
              className={
                exportWorking
                  ? 'far fa-spinner fa-spin mr-2'
                  : 'far fa-check mr-2'
              }
            />{' '}
            Start Export
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
}

ExportModal.propTypes = {
  accountID: PropTypes.string,
}

export default ExportModal
